import { render, staticRenderFns } from "./InputSigarusTimePicker.vue?vue&type=template&id=22be508c&"
import script from "./InputSigarusTimePicker.vue?vue&type=script&lang=js&"
export * from "./InputSigarusTimePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports